import { createSlice } from '@reduxjs/toolkit'
import {
  addProjet,
  addProjetsToPipeline,
  CalculateActionProgressBySource,
  CalculateProjectBudgetPercentage,
  countActionsPriorityByProjetId,
  countActionsStatusByProjetId,
  CountSecurityCheckFamilyByProject,
  deleteProjet,
  fetchSCFCounts,
  getActionCountsBySourceCategory,
  getactionCountsByStatus,
  getactionCountsByTypeAndStatus,
  getActionPriorityCriticalRatio,
  getActionPriorityHighRatio,
  getActionPriorityLowRatio,
  getActionPriorityMediumRatio,
  GetActionsBudgetTable,
  getActionStatusCoursRatio,
  getActionStatusDoneRatio,
  getOverdueInProgressActionRatio,
  getOverdueInProgressCriticalHighActionRatio,
  getProjetbyId,
  getProjetbyMission,
  getProjetbyPipeline,
  getProjets,
  GroupActionsBySecurityCheckFamily,
  removeProjetFromPipeline,
  updateProjet,
} from './projetActions'
import {
  ActionCountsByStatus,
  ActionCountsByStatusAndType,
  ActionsBySourceCategory,
  calculateActionProgressBySourceType,
  calculateProjectBudgetPercentageType,
  CountActionsBySCFResponse,
  countSecurityCheckFamilyByProjectType,
  CoursRatio,
  CriticalRatio,
  DoneRatio,
  getActionsBudgetTableType,
  groupActionsBySecurityCheckFamilyType,
  HighRatio,
  InProgressActionRatio,
  LowRatio,
  MediumRatio,
  Percentage,
  Projet,
  projetOverdueProgressCritical,
  ProjetPriority,
  ProjetRes,
  ProjetRes1,
  ProjetResponse,
} from '../../types/projetTypes'
import { calculateProjectTypeBudgetRatios } from '../../types/missionTypes'

interface ProjetState {
  scfCounts: CountActionsBySCFResponse | null
  projets: Projet[]
  loading: boolean
  projet: Projet | null
  error: string | null
  addedProjet: Projet | null
  updatedProjet: Projet | null
  ProjetResponse: ProjetResponse | null
  projetsbyPipeline: ProjetRes | null
  projetsbyPipelinee: ProjetRes1 | null
  CoursRatio: CoursRatio | null
  DoneRatio: DoneRatio | null
  InProgressActionRatio: InProgressActionRatio | null
  CriticalRatio: CriticalRatio | null
  HighRatio: HighRatio | null
  MediumRatio: MediumRatio | null
  LowRatio: LowRatio | null
  InProgressCriticalHighActionRatio: projetOverdueProgressCritical | null
  ActionsBySourceCategory: ActionsBySourceCategory | null
  ActionCountsByStatus: ActionCountsByStatus | null
  ActionCountsByStatusAndType: ActionCountsByStatusAndType | null
  percentageBudget: Percentage | null
  calculateActionProgressBySource: calculateActionProgressBySourceType | null
  getActionsBudgetTable: getActionsBudgetTableType | null
  calculateProjectBudgetPercentage: calculateProjectBudgetPercentageType | null
  groupActionsBySecurityCheckFamily: groupActionsBySecurityCheckFamilyType | null
  countSecurityCheckFamilyByProject: countSecurityCheckFamilyByProjectType | null
  ProjetPriority: ProjetPriority | null
}

const initialState: ProjetState = {
  scfCounts: null,
  projets: [],
  loading: false,
  error: null,
  addedProjet: null,
  projet: null,
  updatedProjet: null,
  ProjetResponse: null,
  projetsbyPipeline: null,
  projetsbyPipelinee: null,
  CoursRatio: null,
  DoneRatio: null,
  InProgressActionRatio: null,
  CriticalRatio: null,
  HighRatio: null,
  MediumRatio: null,
  LowRatio: null,
  InProgressCriticalHighActionRatio: null,
  ActionsBySourceCategory: null,
  ActionCountsByStatus: null,
  ActionCountsByStatusAndType: null,
  percentageBudget: null,
  calculateActionProgressBySource: null,
  getActionsBudgetTable: null,
  calculateProjectBudgetPercentage: null,
  groupActionsBySecurityCheckFamily: null,
  countSecurityCheckFamilyByProject: null,
  ProjetPriority: null,
}

export const projetSlice = createSlice({
  name: 'projet',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getProjets.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getProjets.fulfilled, (state, action) => {
        state.loading = false
        state.ProjetResponse = {
          projets: action.payload.projets,
          totalPages: action.payload.totalPages ?? 0,
          total: action.payload.total ?? 0,
          status: action.payload.status,
          message: action.payload.message,
        }
      })
      .addCase(getProjets.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })
      .addCase(deleteProjet.fulfilled, (state, action) => {
        state.loading = false
        const deletedProjetId = action.meta.arg

        if (state.ProjetResponse) {
          state.ProjetResponse.projets = (
            state.ProjetResponse.projets ?? []
          ).filter((projet) => projet._id !== deletedProjetId)

          state.ProjetResponse.total = state.ProjetResponse.total ?? 0
          state.ProjetResponse.totalPages = state.ProjetResponse.totalPages ?? 0
          state.ProjetResponse.currentPage =
            state.ProjetResponse.currentPage ?? 0
        }
      })
      .addCase(addProjet.pending, (state) => {
        state.loading = true
        state.error = null
        state.addedProjet = null
      })
      .addCase(addProjet.fulfilled, (state, action) => {
        state.loading = false
        state.addedProjet = action.payload
        console.log(state.addedProjet)
        state.projets.push(action.payload)
      })
      .addCase(addProjet.rejected, (state, action) => {
        state.loading = false
        // Store the translated error message from rejectValue
        state.error =
          action.payload || action.error.message || 'Something went wrong'
        // Set addedProjet with error info for UI to access
        state.addedProjet = {
          status: 400,
          erreur: true,
          message:
            action.payload || action.error.message || 'Something went wrong',
        } as Projet
      })
      .addCase(updateProjet.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(updateProjet.fulfilled, (state, action) => {
        state.loading = false
        state.updatedProjet = action.payload
      })
      .addCase(updateProjet.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })
      .addCase(getProjetbyId.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getProjetbyId.fulfilled, (state, action) => {
        state.loading = false
        state.projet = action.payload
      })
      .addCase(getProjetbyId.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })
      .addCase(getProjetbyPipeline.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getProjetbyPipeline.fulfilled, (state, action) => {
        state.loading = false
        state.projetsbyPipelinee = action.payload
      })
      .addCase(getProjetbyPipeline.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })

      .addCase(getProjetbyMission.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getProjetbyMission.fulfilled, (state, action) => {
        state.loading = false
        state.ProjetResponse = {
          projets: action.payload.projets,
          totalPages: action.payload.totalPages ?? 0,
          total: action.payload.total ?? 0,
        }
      })
      .addCase(getProjetbyMission.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })

      .addCase(removeProjetFromPipeline.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })

      .addCase(removeProjetFromPipeline.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(removeProjetFromPipeline.fulfilled, (state, action) => {
        state.loading = false
        state.projetsbyPipeline = {
          projets: action.payload ?? 0,
        }
      })
      .addCase(addProjetsToPipeline.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })

      .addCase(addProjetsToPipeline.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(addProjetsToPipeline.fulfilled, (state, action) => {
        state.loading = false
        state.projetsbyPipeline = {
          projets: action.payload ?? 0,
        }
      })

      .addCase(countActionsStatusByProjetId.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(countActionsStatusByProjetId.fulfilled, (state, action) => {
        state.loading = false
        state.ProjetResponse = {
          totalActionsCount: action.payload.totalActionsCount ?? 0,
          statusActionsCount: action.payload.statusActionsCount ?? 0,
        }
      })
      .addCase(countActionsStatusByProjetId.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })
      .addCase(getActionStatusCoursRatio.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getActionStatusCoursRatio.fulfilled, (state, action) => {
        state.loading = false
        state.CoursRatio = {
          ratio: action.payload?.ratio ?? 0,
          erreur: action.payload?.erreur,
          status: action.payload?.status,
          message: action.payload?.message,
        }
      })
      .addCase(getActionStatusCoursRatio.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })
      .addCase(getActionStatusDoneRatio.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getActionStatusDoneRatio.fulfilled, (state, action) => {
        state.loading = false
        state.DoneRatio = {
          ratio: action.payload.ratio ?? 0,
        }
      })
      .addCase(getActionStatusDoneRatio.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })
      .addCase(getOverdueInProgressActionRatio.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getOverdueInProgressActionRatio.fulfilled, (state, action) => {
        state.loading = false
        state.InProgressActionRatio = {
          ratio: action.payload.ratio ?? 0,
        }
      })
      .addCase(getOverdueInProgressActionRatio.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })

      .addCase(countActionsPriorityByProjetId.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(countActionsPriorityByProjetId.fulfilled, (state, action) => {
        state.loading = false
        state.ProjetPriority = {
          counts: {
            Critical: action.payload.counts.Critical ?? 0,
            High: action.payload.counts.High ?? 0,
            Medium: action.payload.counts.Medium ?? 0,
            Low: action.payload.counts.Low ?? 0,
          },
        }
      })
      .addCase(countActionsPriorityByProjetId.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })

      .addCase(getActionPriorityCriticalRatio.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getActionPriorityCriticalRatio.fulfilled, (state, action) => {
        state.loading = false
        state.CriticalRatio = {
          ratio: action.payload.ratio ?? 0,
        }
      })
      .addCase(getActionPriorityCriticalRatio.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })

      .addCase(getActionPriorityHighRatio.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getActionPriorityHighRatio.fulfilled, (state, action) => {
        state.loading = false
        state.HighRatio = {
          ratio: action.payload.ratio ?? 0,
        }
      })
      .addCase(getActionPriorityHighRatio.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })
      .addCase(getActionPriorityMediumRatio.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getActionPriorityMediumRatio.fulfilled, (state, action) => {
        state.loading = false
        state.MediumRatio = {
          ratio: action.payload.ratio ?? 0,
        }
      })
      .addCase(getActionPriorityMediumRatio.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })
      .addCase(getActionPriorityLowRatio.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getActionPriorityLowRatio.fulfilled, (state, action) => {
        state.loading = false
        state.LowRatio = {
          ratio: action.payload.ratio ?? 0,
        }
      })
      .addCase(getActionPriorityLowRatio.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })

      .addCase(getOverdueInProgressCriticalHighActionRatio.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(
        getOverdueInProgressCriticalHighActionRatio.fulfilled,
        (state, action) => {
          state.loading = false
          state.InProgressCriticalHighActionRatio = {
            ratio: action.payload.ratio ?? 0,
          }
        }
      )
      .addCase(
        getOverdueInProgressCriticalHighActionRatio.rejected,
        (state, action) => {
          state.loading = false
          state.error = action.error.message || 'Something went wrong'
        }
      )

      .addCase(getActionCountsBySourceCategory.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getActionCountsBySourceCategory.fulfilled, (state, action) => {
        state.loading = false
        state.ActionsBySourceCategory = {
          counts: {
            audit: action.payload.counts?.audit ?? 0,
            incident: action.payload.counts?.incident ?? 0,
            risque: action.payload.counts?.risque ?? 0,
          },
        }
      })
      .addCase(getActionCountsBySourceCategory.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })

      .addCase(getactionCountsByStatus.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getactionCountsByStatus.fulfilled, (state, action) => {
        state.loading = false
        state.ActionCountsByStatus = {
          counts: {
            'A faire': action.payload.counts?.['A faire'] ?? 0,
            'En attente': action.payload.counts?.['En attente'] ?? 0,
            'En cours': action.payload.counts?.['En cours'] ?? 0,
            Suspendu: action.payload.counts?.Suspendu ?? 0,
            Terminé: action.payload.counts?.Terminé ?? 0,
            IT: undefined,
            Physique: undefined,
            Opérationnel: undefined,
            Organisationnel: undefined,
            Gouvernance: undefined,
          },
        }
      })
      .addCase(getactionCountsByStatus.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })

      .addCase(getactionCountsByTypeAndStatus.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getactionCountsByTypeAndStatus.fulfilled, (state, action) => {
        state.loading = false
        state.ActionCountsByStatusAndType = {
          counts: {
            Gouvernance: {
              'En attente': action.payload.counts.Gouvernance['En attente'],
              'En cours': action.payload.counts.Gouvernance['En cours'],
              'A faire': action.payload.counts.Gouvernance['A faire'],
              Suspendu: action.payload.counts.Gouvernance.Suspendu,
              Terminé: action.payload.counts.Gouvernance.Terminé,
            },
            Organisationnel: {
              'En attente': action.payload.counts.Organisationnel['En attente'],
              'En cours': action.payload.counts.Organisationnel['En cours'],
              'A faire': action.payload.counts.Organisationnel['A faire'],
              Suspendu: action.payload.counts.Organisationnel.Suspendu,
              Terminé: action.payload.counts.Organisationnel.Terminé,
            },
            Opérationnel: {
              'En attente': action.payload.counts.Opérationnel['En attente'],
              'En cours': action.payload.counts.Opérationnel['En cours'],
              'A faire': action.payload.counts.Opérationnel['A faire'],
              Suspendu: action.payload.counts.Opérationnel.Suspendu,
              Terminé: action.payload.counts.Opérationnel.Terminé,
            },
            Physique: {
              'En attente': action.payload.counts.Physique['En attente'],
              'En cours': action.payload.counts.Physique['En cours'],
              'A faire': action.payload.counts.Physique['A faire'],
              Suspendu: action.payload.counts.Physique.Suspendu,
              Terminé: action.payload.counts.Physique.Terminé,
            },
            IT: {
              'En attente': action.payload.counts.IT['En attente'],
              'En cours': action.payload.counts.IT['En cours'],
              'A faire': action.payload.counts.IT['A faire'],
              Suspendu: action.payload.counts.IT.Suspendu,
              Terminé: action.payload.counts.IT.Terminé,
            },
          },
        }
      })
      .addCase(getactionCountsByTypeAndStatus.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })

      .addCase(CalculateProjectBudgetPercentage.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(CalculateProjectBudgetPercentage.fulfilled, (state, action) => {
        state.loading = false
        state.percentageBudget = {
          budgetPercentage: action.payload.budgetPercentage,
        }
      })
      .addCase(CalculateProjectBudgetPercentage.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })

      .addCase(CalculateActionProgressBySource.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(CalculateActionProgressBySource.fulfilled, (state, action) => {
        state.loading = false
        state.calculateActionProgressBySource = {
          rates: {
            SourceRisque: {
              'A faire': action.payload.rates?.SourceRisque?.['A faire'] ?? 0,
              'En attente':
                action.payload.rates?.SourceRisque?.['En attente'] ?? 0,
              'En cours': action.payload.rates?.SourceRisque?.['En cours'] ?? 0,
              Suspendu: action.payload.rates?.SourceRisque?.Suspendu ?? 0,
              Terminé: action.payload.rates?.SourceRisque?.Terminé ?? 0,
            },
            SourceIncident: {
              'A faire': action.payload.rates?.SourceIncident?.['A faire'] ?? 0,
              'En attente':
                action.payload.rates?.SourceIncident?.['En attente'] ?? 0,
              'En cours':
                action.payload.rates?.SourceIncident?.['En cours'] ?? 0,
              Suspendu: action.payload.rates?.SourceIncident?.Suspendu ?? 0,
              Terminé: action.payload.rates?.SourceIncident?.Terminé ?? 0,
            },
            SourceAudit: {
              'A faire': action.payload.rates?.SourceAudit?.['A faire'] ?? 0,
              'En attente':
                action.payload.rates?.SourceAudit?.['En attente'] ?? 0,
              'En cours': action.payload.rates?.SourceAudit?.['En cours'] ?? 0,
              Suspendu: action.payload.rates?.SourceAudit?.Suspendu ?? 0,
              Terminé: action.payload.rates?.SourceAudit?.Terminé ?? 0,
            },
          },
        }
      })

      .addCase(CalculateActionProgressBySource.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })

      .addCase(GetActionsBudgetTable.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(GetActionsBudgetTable.fulfilled, (state, action) => {
        state.loading = false
        state.getActionsBudgetTable = {
          table: action.payload.table.map(
            (item: { name: string; budget: number }) => ({
              name: item.name,
              budget: item.budget,
            })
          ),
        }
      })
      .addCase(GetActionsBudgetTable.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })

      // .addCase(CalculateProjectBudgetPercentage.pending, (state) => {
      //   state.loading = true
      //   state.error = null
      // })
      // .addCase(CalculateProjectBudgetPercentage.fulfilled, (state, action) => {
      //   state.loading = false
      //   state.calculateProjectBudgetPercentage =  {
      //     budgetPercentage : action.payload.budgetPercentage}

      // })
      // .addCase(CalculateProjectBudgetPercentage.rejected, (state, action) => {
      //   state.loading = false
      //   state.error = action.error.message || 'Something went wrong'
      // })

      // .addCase(GroupActionsBySecurityCheckFamily.pending, (state) => {
      //   state.loading = true
      //   state.error = null
      // })
      // .addCase(GroupActionsBySecurityCheckFamily.fulfilled, (state, action) => {
      //   state.loading = false
      //   state.groupActionsBySecurityCheckFamily =  {
      //     groups : action.payload.groups}

      // })
      // .addCase(GroupActionsBySecurityCheckFamily.rejected, (state, action) => {
      //   state.loading = false
      //   state.error = action.error.message || 'Something went wrong'
      // })

      .addCase(GroupActionsBySecurityCheckFamily.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(GroupActionsBySecurityCheckFamily.fulfilled, (state, action) => {
        state.loading = false
        state.groupActionsBySecurityCheckFamily = {
          groups: action.payload.groups,
        }
      })
      .addCase(GroupActionsBySecurityCheckFamily.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })

      .addCase(CountSecurityCheckFamilyByProject.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(CountSecurityCheckFamilyByProject.fulfilled, (state, action) => {
        state.loading = false
        console.log('action.payload', action.payload)
        state.countSecurityCheckFamilyByProject = action.payload
      })
      .addCase(CountSecurityCheckFamilyByProject.rejected, (state, action) => {
        state.loading = false
        state.countSecurityCheckFamilyByProject = {
          counts: {},
        }
      })
      .addCase(fetchSCFCounts.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchSCFCounts.fulfilled, (state, action) => {
        state.loading = false
        state.scfCounts = action.payload
      })
      .addCase(fetchSCFCounts.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload || 'Something went wrong'
      })
  },
})

export default projetSlice.reducer
